<template>
  <div>
    <b-collapse id="collapse-conversion-rates" class="my-2">
      <dropdown
        class="mb-3 flex-grow-1"
        :options="currencyOptions"
        :value="selectedCurrency"
        :onChange="val => (selectedCurrency = val)"
        placeholder="SELECT A CURRENCY TO CONVERT FROM"
      />

      <table class="acada-table ">
        <colgroup>
          <col style="width: 80%" />
          <col style="width: 20%" />
        </colgroup>

        <tr>
          <th>Date Applicable From</th>
          <th>Rate</th>
        </tr>

        <tr
          v-for="conversionRate in orgConversionRates[selectedCurrency]"
          :key="conversionRate.id"
        >
          <td>{{ formatDate(conversionRate.startDate) }}</td>
          <td>{{ conversionRate.rate }}</td>
        </tr>
      </table>

      <b-overlay v-if="selectedCurrency > -1" :show="loading" rounded="sm">
        <div class="mt-2" v-if="addingRate">
          <div class="new-rate">
            <div class=" flex-grow-1">
              <span class="start-date">APPLICABLE FROM DATE</span>
              <datepicker
                :value="newRate.startDate"
                mode="single"
                :onChange="val => updateDate(val, newRate)"
                placeholder="Select date"
              />
            </div>
            <div class="ml-2">
              <span>RATE</span>
              <b-form-input
                class="rate"
                style="width:100px"
                v-model="newRate.rate"
                placeholder="Rate"
                type="number"
              />
            </div>
            <div class="buttons ml-2">
              <b-icon-check-square
                style="cursor: pointer"
                @click="addRate"
                font-scale="1"
              />
              <b-icon-x-circle
                style="cursor: pointer"
                @click="addingRate = false"
                font-scale="1"
              />
            </div>
          </div>
          <div class="error" v-show="error">{{ error }}</div>
        </div>
        <b-btn
          v-else
          class="mt-2"
          @click="addingRate = true"
          variant="outline-dark"
          block
          >Add a rate</b-btn
        >
      </b-overlay>
    </b-collapse>
  </div>
</template>

<script>
import { BIconCheckSquare, BIconXCircle } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import Dropdown from './Dropdown';
import Datepicker from './Datepicker';
import moment from 'moment';
import Vue from 'vue';
import api from '../api';
export default {
  components: {
    Dropdown,
    Datepicker,
    BIconCheckSquare,
    BIconXCircle,
  },
  props: {
    org: Object,
    orgId: [Number, String],
    orgCurrencyId: [Number, String],
  },
  data() {
    return {
      loading: false,
      selectedCurrency: -1,
      addingRate: false,
      newRate: { startDate: '', rate: 0 },
      error: '',
    };
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'collapse-conversion-rates')
        this.$emit('showChanged', isJustShown);
    });
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    updateDate(date, conversionRate) {
      if (date) {
        const new_date = moment(date, [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);
        Vue.set(conversionRate, 'startDate', new_date.toISOString());
      } else {
        Vue.set(conversionRate, 'startDate', null);
      }
    },
    async addRate() {
      try {
        this.loading = true;
        const newRate = {};
        Object.assign(newRate, this.newRate);
        newRate.fromCurrId = this.selectedCurrency;
        newRate.toCurrId = this.orgCurrencyId;
        if (
          newRate.startDate === '' ||
          newRate.startDate === null ||
          newRate.rate === 0
        )
          return;
        const {
          data: { data },
        } = await api.createConversionRate(this.orgId, newRate);
        await this.$store.dispatch('getCurrencies');
        this.$emit('newRate', data.createdConversionRate);
        this.addingRate = false;
        this.newRate = { startDate: '', rate: 0 };
        this.error = '';
      } catch (e) {
        console.error(e);
        this.error = 'Could not create new exchange rate';
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters(['currencies', 'currencyById']),
    orgConversionRates() {
      const rates = this.org.conversionRates
        ? this.org.conversionRates.reduce((r, a) => {
            r[a.fromCurrId] = r[a.fromCurrId] || [];
            r[a.fromCurrId].push(a);
            return r;
          }, Object.create(null))
        : [];
      return rates;
    },
    currencyOptions() {
      return this.currencies
        .filter(currency => currency.id !== this.orgCurrencyId)
        .map(currency => ({
          text: currency.code,
          value: currency.id,
        }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.conversion-rate {
  display: flex;
  align-items: center;
  padding: 10;
  box-sizing: border-box;
  border-radius: 2px;
  border-width: 1px;
  //   border-style: solid;
  border-color: -internal-light-dark(rgb(133, 133, 133), rgb(133, 133, 133));

  //   position: relative;

  //   .material-select {
  //     margin-right: 30px;
  //     min-width: 120px;

  //     &:first-child {
  //       min-width: 90px;
  //     }
  //   }

  //   .clear {
  //     position: absolute;
  //     right: -73px;
  //     top: calc(50% - 38px);
  //     cursor: pointer;
  //     padding: 28px;
  //     opacity: 0;
  //     transition: opacity 0.3s;
  //   }

  &:hover {
    .clear {
      opacity: 1;
    }
  }
}

.add-btn {
  border: 1px solid black;
  border-radius: 2px;
  margin-right: 1px;
  // padding: 1px;
  align-self: center;
}

.plus {
  :hover {
    color: gray;
  }
}

.new-rate {
  display: flex;
  align-items: center;

  span {
    position: absolute;
    pointer-events: none;
    color: #929da9;
    margin: 0;
    width: 100%;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    display: block;
  }

  .start-date {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .rate {
    margin-top: 15px;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 2px;
    margin-top: 15px;
    height: 40px;
  }
}

.error {
  color: $red;
  text-align: center;
  width: 100%;
  top: calc(50% + 160px);
  font-size: 14px;
}
</style>
